var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, when } from "mobx";
export class SimpleDialogModel {
    constructor() {
        this.open = false;
        this.lastSelectedChoice = null;
    }
    show() {
        this.lastSelectedChoice = null;
        this.open = true;
    }
    async showAndWait() {
        this.show();
        await when(() => !this.open);
        if (this.lastSelectedChoice === null) {
            throw new Error("No dialog choice was recorded");
        }
        return this.lastSelectedChoice;
    }
    onChoice(choice) {
        this.lastSelectedChoice = choice;
        this.open = false;
    }
}
__decorate([
    observable
], SimpleDialogModel.prototype, "open", void 0);
__decorate([
    observable
], SimpleDialogModel.prototype, "lastSelectedChoice", void 0);
